import { log } from '@deck.gl/core';
export function assert(condition, message) {
  log.assert(condition, message);
}
//# sourceMappingURL=utils.js.map